import { RoutesConst } from "../routeConstant";
// /manage
var mainManageURL = "".concat(RoutesConst.ROOT).concat(RoutesConst.MANAGE);
/** Урлы роутов для управоения */
export var RoutesListManage = {
    /** Страница управления */
    getManage: function () { return mainManageURL; },
    /** Список видов спорта */
    getSportsList: function () { return "".concat(mainManageURL, "/").concat(RoutesConst.SPORTS); },
    getSportEdit: function (id) {
        return "".concat(mainManageURL, "/").concat(RoutesConst.SPORTS, "/").concat(id, "/").concat(RoutesConst.EDIT);
    },
    getSportAdd: function () {
        return "".concat(mainManageURL, "/").concat(RoutesConst.SPORTS, "/").concat(RoutesConst.ADD);
    },
    /** Список городов */
    getCitiesList: function () { return "".concat(mainManageURL, "/").concat(RoutesConst.CITIES); },
    getCityEdit: function (id) {
        return "".concat(mainManageURL, "/").concat(RoutesConst.CITIES, "/").concat(id, "/").concat(RoutesConst.EDIT);
    },
    getCityAdd: function () { return "".concat(mainManageURL, "/").concat(RoutesConst.CITIES, "/").concat(RoutesConst.ADD); },
};
